import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
    selector: 'app-account-settings-security',
    templateUrl: './account-settings-security.component.html',
    styleUrls: ['./account-settings-security.component.scss'],
    standalone: true
})
export class AccountSettingsSecurityComponent {
  accountsDetails: any;
  accountId!: string;
  data: any;
  constructor(
    private AccountsService: AccountsService,
    private route: ActivatedRoute,
    private _toast: ToastService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.accountId = params['account_id'];
      this.getAccountSecurityConfig(this.accountId)
    })
  }

  /**
   * [getAccountSecurityConfig  -  This method fetches the account level security configuration]
   */
  getAccountSecurityConfig(accountId: string): void {
    this.AccountsService.getAccountDetail(accountId).subscribe(
      (response) => {
        this.accountsDetails = response.data.account;
        console.log("Getting account level security config", this.accountsDetails);
      },
      (error) => {
        console.error('Error during account details API call:', error);
      }
    );
  }

   /**
   * Function - updateAccountDetails() 
   * Added by - Hitesh Sharma
   * @Description  This function will update the account details
   */
   updateAccountDetails(){
    this.data = {};

    // here first we need to validate the request body data which need to be update then only we call the update service method. for now only prepared update method.

    this.AccountsService.updateAccountsConfiguration(this.accountId, this.data).subscribe(
      (response) => {
        // Handle the response if needed
        if (response && response.data.code == 0) {
          this._toast.showPopup('SUCCESS', 'Success', 'Account settings updated successfully.', 5000);
        } else {
          if (response && response.data && response.data.error_message) {
            this._toast.showPopup('ERROR', 'Error', response.data.error_message, 5000);
          } else {
            this._toast.showPopup('ERROR', 'Error', "Error while updating Account settings.", 5000);
          }
        }
      },
      (error) => {
        console.error('Error while updating Account settings:', error);
        // Handle the error if needed
        this._toast.showPopup('ERROR', 'Error', 'Error while updating Account settings.', 5000)
      }
    );
  }
}
